// @flow
import React, { Component } from 'react';
import { injectIntl, type IntlShape } from 'react-intl';
import type { Role } from 'state/types';
import { getLocalizedRoleName } from 'util/roleUtils';

type Props = {
  index: number,
  intl: IntlShape,
  isSelected: boolean,
  role: Role,
  onClick: (SyntheticMouseEvent<>, number) => void,
};

class RoleRow extends Component<Props> {
  handleClick: Function;

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e: SyntheticMouseEvent<>) {
    this.props.onClick(e, this.props.index);
  }

  render() {
    const { intl, isSelected, role } = this.props;
    const className = `role-row has-pointer ${isSelected ? 'is-selected' : ''}`;
    return (
      <tr className={className} onClick={this.handleClick}>
        <td className="list-item no-padding" data-test-name="role-item">
          <span className="role-item">
            {getLocalizedRoleName(intl, role.name)}
          </span>
        </td>
      </tr>
    );
  }
}

export default injectIntl(RoleRow);



// WEBPACK FOOTER //
// ./src/view/Pages/RolesPage/RoleRow.js